import {getTestProps} from '@benchling/js-test-utils';
import {Anchor, createStyles, Group, Stack} from '@mantine/core';
import React from 'react';

import {FONT_PROXIMA_14} from 'styles/FontConstants';
import {ChipSize} from 'ui-library/chips/Chip';
import ChipList from 'ui-library/chips/ChipList';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const useStyles = createStyles((theme) => ({
  topBar: {
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
  },
  backLink: {
    cursor: 'pointer',
    fontWeight: 600,
  },
  multimerComponentsLabel: {
    ...FONT_PROXIMA_14,
    color: theme.colors.gray[7],
    fontWeight: 'bold',
  },
}));

/**
 * Back link + multimer-component chip list shared by the AlphaFold and protein structure viewers.
 */
export function StructurePredictionHeader({
  testComponent,
  onBack,
  componentIds,
}: {
  testComponent: string;
  onBack: () => void;
  componentIds: ReadonlyArray<string>;
}): JSX.Element {
  const {classes} = useStyles();
  const chipList = (
    <ChipList itemIds={[...componentIds]} chipSize={ChipSize.MINI} maxChips={3} isVertical={false} />
  );
  return (
    <Group
      position="apart"
      px="md"
      py="sm"
      className={classes.topBar}
      {...getTestProps({component: testComponent, element: 'viewerBackBar'})}
    >
      <Anchor
        component="button"
        type="button"
        className={classes.backLink}
        onClick={onBack}
        {...getTestProps({component: testComponent, element: 'backButton'})}
      >
        <Group spacing="xs" noWrap={true}>
          <BenchlingIcon icon="chevron-left" />
          <span>Back</span>
        </Group>
      </Anchor>
      {componentIds.length > 1 && (
        <Stack spacing="xxs" align="flex-start" maw={400}>
          <span className={classes.multimerComponentsLabel}>Multimer Components</span>
          {chipList}
        </Stack>
      )}
    </Group>
  );
}
